import { RefObject } from "react";

/**
 * Calculates the number of lines of text an element has based on its size, fontSize and lineHeight.
 *
 * @param {RefObject<Element>} ref - The reference of the object.
 * @returns {number} The number of lines of text that the element has or 0 when the ref is null.
 */
export const countRows = (ref: RefObject<Element>): number => {
	if (!ref.current) {
		return 0;
	}

	const lineHeight = parseFloat(window.getComputedStyle(ref.current).lineHeight);
	const height = ref.current.getBoundingClientRect().height;

	return Math.round(height / lineHeight);
};
